import { ITenant } from './app.interface'

const env = (window as any)._env_ ?? {}

export const appEnv = {
  mode: env.mode ?? 'production',
  apiHost: env.apiHost,
  azureActiveDirectoryAppClientId: env.azureActiveDirectoryAppClientId,
  azureActiveDirectoryAppAuthority: env.azureActiveDirectoryAppAuthority,
  azureActiveDirectoryAppRedirectUrl: env.azureActiveDirectoryAppRedirectUrl,
  gaTrackingId: env.gaTrackingId,
  tenant: (env.tenant ?? 'demo') as ITenant,
}
